<div class="container-fluid inquiry-container">
  <div
    class="sticky-content-container"
    baseIsSticky
    stickyClass="sticky-top"
    [stickyScrollDistance]="stickyHeaderScrollDistance"
    (stickyChange)="onStickyChange($event)"
  >
    <div class="position-relative">
      <div class="inquiry-calendar position-relative">
        <base-inquiry-calendar></base-inquiry-calendar>
      </div>
      <div class="inquiry-actions-and-filters py-4">
        <base-customer-offers-search-and-legend
          (sortItemClicked)="sortOffersList($event)"
          [activeSortOrderDirection]="listOrderDirection"
          [activeSortOrderKey]="listOrderKey"
          [branches]="branches"
          [filtersForm]="filtersForm"
          [isFiltersVisible]="hasFiltersValues"
          [mainQualifications]="mainQualifications"
          [widgetTemplate]="widgetTemplate"
          class="py-4"
        ></base-customer-offers-search-and-legend>
      </div>
    </div>
  </div>
  <div class="position-relative pb-8">
    <base-customer-inquiry-offers-list
      [offers]="filteredOffers"
      [shiftTimesWithFlex]="shiftTimesWithFlex"
      (scrollListDown)="loadOffersNextPage()"
    ></base-customer-inquiry-offers-list>
  </div>
</div>

<base-inquiry-details-sidebar
  [inquiryId]="copiedInquiry.id"
  [inquiry]="inquiry"
  [isSidebarVisible]="isSidebarVisible"
  [offersCount]="offersCount"
  [shiftTimes]="shiftTimes"
></base-inquiry-details-sidebar>

<ng-template #widgetTemplate>
  <div
    [ngClass]="inquiry.status !== baseInquiryStatus.closed ? 'justify-content-end' : 'justify-content-between'"
    class="d-flex align-items-center right-content h-100"
  >
    <base-action-dropdown
      *ngIf="inquiry.status !== baseInquiryStatus.closed"
      [color]="inquiry.status === baseInquiryStatus.unpublished ? 'outline-danger' : 'outline-success'"
      [items]="inquiry.status === baseInquiryStatus.unpublished ? ['action.close', 'action.publish'] : ['action.close']"
      [label]="'states.' + inquiryStatus[inquiry.status]"
      class="mw-100 me-3"
      (listItemClicked)="handleClick($event)"
    >
    </base-action-dropdown>
    <div
      *ngIf="inquiry.status === this.baseInquiryStatus.closed"
      class="reason-info"
    >
      <p
        *ngIf="inquiry?.closedBy; else closedBySystemMessage"
        baseDynamicFontSize="100"
        class="mb-0 me-3 text-center"
      >
        <ng-container *ngIf="inquiry?.closedNote; else noClosingReasonSpecified">
          {{ 'operations.reason' | translate }}: {{ inquiry?.closedNote }}
        </ng-container>
        <ng-template #noClosingReasonSpecified>
          <span>{{ 'inquiry.closeInquiry.closedWithoutReason' | translate }}</span>
        </ng-template>
      </p>
      <ng-template #closedBySystemMessage>
        <p class="mb-0 me-3 text-center">{{ 'inquiry.closedBySystem' | translate }}</p>
      </ng-template>
    </div>
    <base-button
      (btnClick)="copyInquiryHandler($event, inquiry)"
      [iconSize]="buttonSizes.md"
      [ngbTooltip]="'inquiry.createByCopy' | translate"
      color="dark"
      icon="fa-solid fa-copy"
      stateClass="pe-1"
    ></base-button>
  </div>
</ng-template>

<ng-template #staffRequest>
  <base-customer-staff-request-modal
    [inquiry]="copiedInquiry"
    [isInquiryDefaultFilter]="true"
    [modalRef]="modalRef"
  ></base-customer-staff-request-modal>
</ng-template>

<ng-template #closeInquiryModal>
  <base-customer-close-inquiry-form [modalRef]="onInquiryCloseModalRef"></base-customer-close-inquiry-form>
</ng-template>
